import { render, staticRenderFns } from "./EmployeeSalarySettingAdd.vue?vue&type=template&id=23c0b52d&scoped=true&"
import script from "./EmployeeSalarySettingAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0b52d",
  null
  
)

export default component.exports